import UsernameFormSession from '../usernameForm/usernameFormTs';
import PasswordAuthenticatorSession from '../passwordForm/passwordFormTs';
import OTPSession from '../otpSession+UI/otpSession';
import ChangeUsernameFormSession from '../change-username/changeUsernameTs';
import ChangeRecoveryNumberFormSession from '../change-recovery-number/changeRecoveryNumberTs';
import ChangePasswordFormSession from '../change-password/changePasswordTs';
import ConfirmChangePasswordFormSession from '../change-password/confirmPasswordTs';
import AccountSelectionSession from '../account-selection/accountSelectionFormTs';
import LanguageFormSession from '../set-language/languageFormTs';
import RegisterFormSession from '../register/registerFormTs';
import SetMultiFactorAuthSession from '../set-multi-factor-auth/setMultiFactorAuthTs';
import MultiFactorAuthSuccessSession from '../multi-factor-auth-success/multiFactorAuthSuccessTs';
import SecurityQuestionFormSession from '../security-question/securityQuestionFormTs';
import UpdateMultiFactorAuthSession from '../update-multi-factor-auth/updateMultiFactorauthFormTs';
import UsernameNoRecaptchaFormSession from '../username-form-no-recaptcha/UsernameNoRecaptchaFormSession';
import IgniteTvSelectionFormSession from '../ignite-tv-account-selection/igniteTvcAcountFormTs';
import RegisterPassKeyPromptSession from '../pass-key/register-pass-key-prompt/register-pass-key-promptTs';
import PassKeyTermsAndConditionsSession from '../pass-key/pass-key-terms-and-conditions/pass-key-terms-and-conditionsTs';
import PassKeySuccessFormSession from '../pass-key/pass-key-terms-success-form/pass-key-terms-success-formTs';
import RegisterPassKeyFormSession from '../pass-key/pass-key-register-form/pass-key-register-formTs';
import PassKeyAuthenticateFormSession from '../pass-key/pass-key-authenticate-form/pass-key-authenticate-formTs';
import { ProfilePassKeySettingsComponent } from '../pass-key/profile-pass-key-settings/profile-pass-key-settings.component';
import ProfilePasskeySettingsFormSession from '../pass-key/profile-pass-key-settings/profile-pass-key-settingsT';
import PasskeyDeleteSuccessForm from '../pass-key/pass-key-delete-success/pass-key-delete-successFormTs';
import PasskeyDeleteFailureForm from '../pass-key/pass-key-delete-failure/pass-key-delete-failureFormTs';
import DrsDenyForm from '../drs-deny/drsDenyTs';


const xmui: com.ts.mobile.sdk.UIHandler = (window as any).xmui;
let clientContextObj: object;

function CustomUIHandler() {
    (xmui as any).XmUIHandler.call(this);
}

CustomUIHandler.prototype = Object.create((xmui as any).XmUIHandler.prototype);
CustomUIHandler.prototype.constructor = CustomUIHandler;

CustomUIHandler.prototype.createOtpAuthSession = (
  title: string,
  username: string,
  possibleTargets: Array<com.ts.mobile.sdk.OtpTarget>,
  autoExecedTarget: com.ts.mobile.sdk.OtpTarget | null
): com.ts.mobile.sdk.UIAuthenticatorSessionOtp => {
  return new OTPSession(title, username, possibleTargets, autoExecedTarget);
};

// Transmit provided code
// Invoked anytime when the journey is ended

CustomUIHandler.prototype.controlFlowEnded =
function controlFlowEnded(error, clientContext)
{
    if (error) {
      if ( error?._data?.failure_data?.reason?.data.code === 'RC01'){
          const url = clientContext['cookieService'].get('redirect_uri');
          const state = clientContext['cookieService'].get('state');
          const errorCode  = 'rc01';
          let appendChar = '?';
          if (url.includes('?'))
          {
              appendChar = '&';
          }
          window.location.href = url + appendChar + 'error=' + errorCode + '&error_description=rc01'
          + '&lang=' + clientContext['cookieService'].get('lang')
          + '&state=' + state;
      }
      console.log('error: ', error);
    } else {
    console.log('control flow ended');
    }
  };

CustomUIHandler.prototype.createFormSession = (
  formId: string,
  payload: any
): com.ts.mobile.sdk.UIFormSession => {
  console.log('createFormSession', formId);
  switch (formId) {
      case 'usernamePrompt':
        return new UsernameFormSession(formId, payload);

      case 'changeUsernameProfile':
        return new ChangeUsernameFormSession(formId, payload);

      case 'changeRecoveryNumberProfile':
        return new ChangeRecoveryNumberFormSession(formId, payload);

      case 'selectAccount':
        return new AccountSelectionSession(formId, payload);

      case 'language':
        return new LanguageFormSession(formId, payload);

      // registration
      case 'create':
        clientContextObj['cookieService'].set('register', formId, undefined, undefined, null, true, 'None');
        return new RegisterFormSession(formId, payload);

      // MFA
      case 'registerMFA':
        console.log('MFA session started', formId);
        return new SetMultiFactorAuthSession(formId, payload);

      case 'mfaSuccessForm':
        return new MultiFactorAuthSuccessSession(formId, payload);

      case 'profileUpdateMFA':
        return new UpdateMultiFactorAuthSession(formId, payload);

      case 'username-no-recaptcha':
        return new UsernameNoRecaptchaFormSession(formId, payload);

      case 'userSelection':
        return new IgniteTvSelectionFormSession(formId, payload);

      case 'registerPasskeyPrompt':
        return new RegisterPassKeyPromptSession(formId, payload);

      case 'terms_conditions':
        return new PassKeyTermsAndConditionsSession(formId, payload);

      case 'passkeySuccessForm':
        return new PassKeySuccessFormSession(formId, payload);

      case 'registerPasskey' :
        return new RegisterPassKeyFormSession(formId, payload);

      case 'passkeyauthenticateform':
        return new PassKeyAuthenticateFormSession(formId, payload);

      case 'profileDeletePasskey':
        return new ProfilePasskeySettingsFormSession(formId, payload);

      case 'passkeyDeleteSuccess':
        return new PasskeyDeleteSuccessForm(formId, payload);

      case 'passkeyDeleteFailure':
        return new PasskeyDeleteFailureForm(formId, payload);

      case 'drs_deny_error':
         return new DrsDenyForm(formId, payload);
  }
};

CustomUIHandler.prototype.createPasswordAuthSession = (
  title: string,
  username: string,
) => {
  console.log('PasswordAuthSession invoke');
  const flow =  clientContextObj['cookieService'].get('customFlow');
  if (flow === 'oldPassword'){
    return new ChangePasswordFormSession(title, username);
  }
  else if (flow === 'newPassword'){
    return new ConfirmChangePasswordFormSession(title, username);
  }
  else{
    return new PasswordAuthenticatorSession(title, username);
  }
};

CustomUIHandler.prototype.createPlaceholderAuthSession  = (
  placeholderName, placeholderType, title, username,
  authenticatorConfiguredData, serverPayload
) => {
  console.log('Yahoo ForgotPassword session started');
  return new SecurityQuestionFormSession(title, username);
};


CustomUIHandler.prototype.handlePolicyRedirect  = (
  redirectType: com.ts.mobile.sdk.RedirectInput, policyId: string | null,
  userId: string | null, additionalParameters: object | null, clientContext: object | null
) => {

    clientContext['UserId'] = userId;
    return new Promise((resolve, reject) => {
        try {
          resolve(com.ts.mobile.sdk.RedirectInput.create(com.ts.mobile.sdk.RedirectResponseType.RedirectToPolicy));
        }
        catch (e) {
          console.log('handlePolicyRedirect error: ', e);
        }
    });
};


CustomUIHandler.prototype.handlePolicyRejection =
(title, text, buttonText, failureData, actionContext, clientContext) => {

  if (failureData?.reason?.data?.error === 'register' ||
      failureData?.reason?.data?.error === 'forgotusername' ||
      failureData?.reason?.data?.error === 'account_forgotusername' ||
      failureData?.reason?.data?.error === 'RC01'){

    const errorCode = failureData.reason.data.error;
    const errorDesc = failureData.reason.data.error_desc;
    const url = clientContext['redirect_uri'];
    const state = clientContext['state'];
    let appendChar = '?';
    if (url.includes('?'))
    {
       appendChar = '&';
    }

    return window.location.href = url + appendChar + 'error=' + errorCode + '&error_description=' + errorDesc
    + '&lang=' + clientContext['cookieService'].get('lang')
    + '&state=' + state;

  }
  else{
    return Promise.resolve(com.ts.mobile.sdk.ConfirmationInput.create(-1));
  }
};


CustomUIHandler.prototype.processJsonData = (
  jsonData: object, actionContext: com.ts.mobile.sdk.PolicyAction, clientContext: object | null
): Promise<com.ts.mobile.sdk.JsonDataProcessingResult> => {
  clientContextObj = clientContext;
  return new Promise((resolve, reject) => {
    if (jsonData['userID']) {

       clientContext['userID'] = jsonData['userID'];
       clientContextObj['cookieService'].set('userEmail', jsonData['userID'], undefined, undefined, null, true, 'None');
      }
    if (jsonData['username']) { clientContext['username'] = jsonData['username']; }
    if (jsonData['flow']) {
      clientContext['flow'] = jsonData['flow'];
      clientContextObj['cookieService'].set('customFlow', clientContext['flow'], undefined, undefined, null, true, 'None');
      clientContextObj['cookieService'].set('flow', clientContext['flow'], undefined, undefined, null, true, 'None');
      clientContextObj['cookieService'].set('regFlow', clientContext['flow'], undefined, undefined, null, true, 'None');
    }
    if (jsonData['redirect_uri']) {
      clientContext['redirect_uri'] = jsonData['redirect_uri'];
      clientContextObj['cookieService'].set('redirect_uri', jsonData['redirect_uri'], undefined, undefined, null, true, 'None');
    }
    if (jsonData['state']) {
      clientContext['state'] = jsonData['state'];
      clientContextObj['cookieService'].set('state', jsonData['state'], undefined, undefined, null, true, 'None');
    }

    // MFA
    if (jsonData['email_mfa']) {
      clientContext['email_mfa'] = jsonData['email_mfa'];
      clientContextObj['cookieService'].set('email_mfa', jsonData['email_mfa'], undefined, undefined, null, true, 'None');
    }
    if (jsonData['mobile_mfa']) {
      clientContext['mobile_mfa'] = jsonData['mobile_mfa'];
      clientContextObj['cookieService'].set('mobile_mfa', jsonData['mobile_mfa'], undefined, undefined, null, true, 'None');
    }
    if (jsonData['skip_mfa']) {
      clientContext['skip_mfa'] = jsonData['skip_mfa'];
      clientContextObj['cookieService'].set('skip_mfa', jsonData['skip_mfa'], undefined, undefined, null, true, 'None');
    }

    // Security Question
    if (jsonData['securityQ']) {
      clientContext['securityQ'] = jsonData['securityQ'];
      clientContextObj['cookieService'].set('securityQ', jsonData['securityQ'], undefined, undefined, null, true, 'None');
    }
    // Profile update MFA
    if (jsonData['MFAEmailStatus']) {
      clientContext['MFAEmailStatus'] = jsonData['MFAEmailStatus'];
    }
    if (jsonData['MFAMobileStatus']) {
      clientContext['MFAMobileStatus'] = jsonData['MFAMobileStatus'];
    }

    // pass-key
    if (jsonData['WebAuthNerror']) {
      clientContext['WebAuthNerror'] = jsonData['WebAuthNerror'];
    }
    if (jsonData['webAuthNDialogResponse']) {
      clientContext['webAuthNDialogResponse'] = jsonData['webAuthNDialogResponse'];
    }

    if (jsonData['DisplayName']) { clientContext['DisplayName'] = jsonData['DisplayName']; }

    if (jsonData['passkeyDetails']) { clientContext['passkeyDetails'] = jsonData['passkeyDetails']; }

    if (jsonData['code']) {
      clientContextObj['cookieService'].set('passwordExpiry', jsonData['code'], undefined, undefined, null, true, 'None');
    }
    if (jsonData['expire_in_days']) {
      clientContextObj['cookieService'].set('passwordExpireDays', jsonData['expire_in_days'], undefined, undefined, null, true, 'None');
    }
    if (jsonData['showPasskeyMsg']) {
         clientContext['showPasskeyMsg'] = jsonData['showPasskeyMsg'];
    }

    resolve(com.ts.mobile.sdk.JsonDataProcessingResult.create(true));
  });
};

export default CustomUIHandler;
